<div class="favorites-listing" *ngIf="userInfo">
  <div class="favorites-listing__header">
    <h1 class="favorites-listing__header-text">Favorite Events</h1>
  </div>
  <app-state-view [promise]="favoritesPromise">
    <loading-state>
      <div class="favorites-listing__loading">
        <app-dots-spinner aria-label="Loading..."></app-dots-spinner>
      </div>
    </loading-state>
    <empty-state>
      <div class="favorites-listing__placeholder">
        <mat-icon class="favorites-listing__placeholder-icon">info</mat-icon>
        <div class="favorites-listing__placeholder-message">No events are currently marked as favorite.</div>
      </div>
    </empty-state>
    <error-state>
      <div class="favorites-listing__placeholder favorites-listing__placeholder--error">
        <mat-icon class="favorites-listing__placeholder-icon">warning</mat-icon>
        <div class="favorites-listing__placeholder-message">
          An error occurred loading your favorite events. Please try again later.
        </div>
      </div>
    </error-state>
    <content-state>
      <div class="favorites-listing__container" *ngIf="favorites && favorites.length > 0; else placeholder">
        <app-event-summary-card #airportEl *ngFor="let aviationEvent of favorites"
                                  class="favorites-listing__card" [aviationEvent]="aviationEvent"
                                  [active]="aviationEvent === activeAirport" [interactive]="true">
        </app-event-summary-card>

        <!-- Placeholder cards to fix layout when the number of events is not divisible by 3 -->
        <div *ngIf="favorites.length % 3 !== 0" class="favorites-listing__card"></div>
        <div *ngIf="(favorites.length + 1) % 3 !== 0" class="favorites-listing__card"></div>
      </div>
    </content-state>
  </app-state-view>
  <ng-template #placeholder>
    <div class="favorites-listing__placeholder">
      <mat-icon class="favorites-listing__placeholder-icon">info</mat-icon>
      <div class="favorites-listing__placeholder-message">No upcoming events are currently marked as a favorite.</div>
    </div>
  </ng-template>
</div>
